(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A service to assist in form validation.
   */
  factory('Validation', ['Utils', 'Logger', function (Utils, Logger) {
    return {
      isBlank: function isBlank(str) {
        return typeof str === "undefined" || str === null || String(str).replace(/\s/g, '').length === 0;
      },
      containsNumeric: function containsNumeric(str) {
        var re = /[0-9]/;
        return re.test(str);
      },
      containsLowercase: function containsLowercase(str) {
        var re = /[a-z]/;
        return re.test(str);
      },
      containsUppercase: function containsUppercase(str) {
        var re = /[A-Z]/;
        return re.test(str);
      },
      containsSpecial: function containsSpecial(str) {
        var re = /[!@#\$%\^&\*\(\)_\+\-=:;<>\?\[\]\{\|}~]/;
        return re.test(str);
      },
      startsWith: function startWith(str, prefix) {
        return str.startsWith(prefix);
      },
      isUrl: function isUrl(str) {
        var re = /[-a-zA-Z0-9@:%_\+.~#?&//=\u00C0-\u1FFF\u2C00-\uD7FF]{2,256}(\.[a-z]{2,4})?\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=\u00C0-\u1FFF\u2C00-\uD7FF]*)?/gi;
        return re.test(str);
      },
      isEmail: function isEmail(str) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9\u00C0-\u1FFF\u2C00-\uD7FF]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(str);
      },
      isEmailExtension: function isEmailExtension(str) {
        var re = /^@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9\u00C0-\u1FFF\u2C00-\uD7FF]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(str);
      },
      isEmailExtensionList: function isEmailExtensionList(str) {
        var emailExtReg = "@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9\xC0-\u1FFF\u2C00-\uD7FF]+.)+[a-zA-Z]{2,}))";
        var re = new RegExp('(^' + emailExtReg + ')([,](' + emailExtReg + ')){0,4}$');
        return re.test(str);
      },
      isTimestamp: function isTimestamp(str) {
        var dateTest = Date.parse(str, "yyyy-MM-dd HH:mm:ss.SSS");
        return dateTest;
      },
      validate: function validate(validationInfo) {
        Logger.trace("Validation:validate");
        var self = this;
        var errors = {};
        angular.forEach(validationInfo, function (item, name) {
          var displayName = item.display || Utils.capitalize(name),
            value = item.value,
            required = item.rules.required || false;

          //See if this is required when some other fields are required or have values
          if (!required && item.rules.requiredWith) {
            angular.forEach(item.rules.requiredWith, function (fieldName) {
              var member = validationInfo[fieldName];
              required = required || member.rules.required || !self.isBlank(member.value);
            });
          }

          //Do required check first
          if (required === true && self.isBlank(value)) {
            errors[name] = errors[name] || displayName + " is a required field.";
            return;
          }

          //The rest of the rules only apply when there is a value.
          if (!self.isBlank(value) || Object.keys(item.rules).indexOf('matches') > -1) {
            angular.forEach(item.rules, function (ruleValue, rule) {
              if (rule === "email" && !self.isEmail(value)) {
                errors[name] = errors[name] || displayName + " is not a valid email address.";
              } else if (rule === "emailExtension" && !self.isEmailExtension(value)) {
                errors[name] = errors[name] || displayName + " is not a valid email extension.";
              } else if (rule === "emailExtensionList" && !self.isEmailExtensionList(value)) {
                errors[name] = errors[name] || displayName + " is not a valid email extension list.";
              } else if (rule === "url" && !self.isUrl(value)) {
                errors[name] = errors[name] || displayName + " is not a valid URL.";
              } else if (rule === "minLength" && !self.isBlank(value) && value.length < ruleValue) {
                errors[name] = errors[name] || displayName + " must be longer than " + ruleValue + " characters.";
              } else if (rule === "maxLength" && !self.isBlank(value) && value.length > ruleValue) {
                errors[name] = errors[name] || displayName + " cannot be longer than " + ruleValue + " characters.";
              } else if (rule === "in" && ruleValue.indexOf(value) === -1) {
                errors[name] = errors[name] || displayName + " '" + value + "' is not valid.";
              } else if (rule === "matches") {
                var toMatch = validationInfo[ruleValue];
                if (value !== toMatch.value) {
                  var toMatchDisplay = toMatch.display || ruleValue;
                  errors[name] = errors[name] || displayName + " must match " + toMatchDisplay + ".";
                }
              } else if (rule === "startsWith") {
                if (!self.startsWith(value, ruleValue)) {
                  errors[name] = errors[name] || displayName + " must begin with '" + ruleValue + "'.";
                }
              } else if (rule === "password") {
                if (value.length < 8) {
                  errors[name] = errors[name] || displayName + " must be longer than " + 8 + " characters.";
                }
                if (!self.containsNumeric(value)) {
                  errors[name] = errors[name] || displayName + " must contain at least one" + " numeric value (0-9).";
                }
                if (!self.containsLowercase(value)) {
                  errors[name] = errors[name] || displayName + " must contain at least one" + " lowercase letter (a-z).";
                }
                if (!self.containsUppercase(value)) {
                  errors[name] = errors[name] || displayName + " must contain at least one" + " uppercase letter (A-Z).";
                }
                if (!self.containsSpecial(value)) {
                  errors[name] = errors[name] || displayName + " must contain at least one " + "special character (!@#$%^&*_+-()={}:;<>|[]!~?).";
                }
              } else if (rule === "multipleEmail") {
                var split = _.map(value.split(","), function (email) {
                  return email.trim();
                });
                var failures = _.reject(split, self.isEmail);
                if (failures.length === 1) {
                  errors[name] = errors[name] || failures[0] + " is not a valid email address.";
                } else if (failures.length > 0) {
                  errors[name] = errors[name] || failures.join(", ") + " are not valid email addresses.";
                }
              } else if (rule === "timestamp" && !self.isTimestamp(value)) {
                errors[name] = errors[name] || displayName + " is not a valid timestamp.";
              }
            });
          }
        });
        return Utils.dictionaryLength(errors) === 0 ? null : errors;
      }
    };
  }]);
})();
